import { render, staticRenderFns } from "./SidemenuEntry.vue?vue&type=template&id=4b5bab9c&"
import script from "./SidemenuEntry.vue?vue&type=script&lang=ts&"
export * from "./SidemenuEntry.vue?vue&type=script&lang=ts&"
import style0 from "./SidemenuEntry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports